import type React from 'react';
import { createContext, useState, useContext } from 'react';

type ExercisePickerContextType = {
  openExercisePickerId: string | null;
  setOpenExercisePickerId: (id: string | null) => void;
};

const ExercisePickerContext = createContext<ExercisePickerContextType>({
  openExercisePickerId: null,
  setOpenExercisePickerId: () => undefined,
});

export const ExercisePickerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [openExercisePickerId, setOpenExercisePickerId] = useState<string | null>(null);

  return (
    <ExercisePickerContext.Provider value={{ openExercisePickerId, setOpenExercisePickerId }}>
      {children}
    </ExercisePickerContext.Provider>
  );
};

export const useExercisePicker = () => useContext(ExercisePickerContext);
